import { Product } from "@b2bportal/purchase-api";
import { BestPriceGuaranteeBanner } from "../../BestPriceGuaranteeBanner";
import styles from "./styles.module.scss";

const PriceBreakdownAdditionalInfo = () => {
  return (
    <div className={styles.PriceBreakdownAdditionalInfo}>
      <BestPriceGuaranteeBanner product={Product.Hotel} />
    </div>
  );
};

export default PriceBreakdownAdditionalInfo;
